export default {

  users: [],
  user: {},

  config: [],

  menus: [],

};
